import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CommentsHeader from '../CommentsHeader';
import CommentsButton from '../CommentsButton';
import CommentsList from '../CommentsList';
import CollaborationGroupsTabs from '../CollaborationGroupsTabs';
import * as GroupsSelectors from '../../selectors/groups';
import * as Selectors from '../../selectors';
import { setCurrentCommentId } from '../../actions/current';
import './style.scss';

export class CommentsPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = { placeholderTabClicked: false };

        this.handlePlaceholderTabClick = this.handlePlaceholderTabClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.onlyOneGroup !== this.props.onlyOneGroup) {
            this.handlePlaceholderTabClick(false);
        }
    }

    handlePlaceholderTabClick(clicked) {
        this.setState({
            placeholderTabClicked: clicked
        });

        this.props.setCurrentCommentId(undefined);
    }

    render() {
        const {
            collaborationsTabSelected,
            isSellerGroupInPreRevisionMode
        } = this.props;

        const { placeholderTabClicked } = this.state;

        const classes = classNames('comments-panel', { 'dark-theme': collaborationsTabSelected || placeholderTabClicked });

        return (
            <div className={classes}>
                <CommentsHeader/>
                <CollaborationGroupsTabs handlePlaceholderTabClick={this.handlePlaceholderTabClick} isPlaceholderTabClicked={placeholderTabClicked}/>
                <CommentsList placeholderTabClicked={placeholderTabClicked}/>
                <CommentsButton isDisplay={!placeholderTabClicked && !isSellerGroupInPreRevisionMode}/>
            </div>
        );
    }
}

CommentsPanel.propTypes = {
    collaborationsTabSelected: PropTypes.bool,
    setCurrentCommentId: PropTypes.func,
    onlyOneGroup: PropTypes.bool,
    isSellerGroupInPreRevisionMode: PropTypes.bool
};

const mapStateToProps = (state) => ({
    collaborationsTabSelected: GroupsSelectors.isExternalCollaborationTabSelected(state),
    onlyOneGroup: GroupsSelectors.isSingle(state),
    isSellerGroupInPreRevisionMode: Selectors.isSellerGroupInPreRevisionMode(state)
});

export default connect(mapStateToProps, { setCurrentCommentId })(CommentsPanel);
